import * as React from "react";

export const SkeletonCard: React.FC = () => {
  return (
    <div className="skeleton-card">
      <div className="skeleton-image">
        <div className="skeleton-shimmer" />
      </div>
      <div className="skeleton-meta">
        <div className="skeleton-title">
          <div className="skeleton-shimmer" />
        </div>
        <div className="skeleton-price">
          <div className="skeleton-shimmer" />
        </div>
        <div className="skeleton-swatches">
          <div className="skeleton-swatch skeleton-shimmer" />
          <div className="skeleton-swatch skeleton-shimmer" />
          <div className="skeleton-swatch skeleton-shimmer" />
          <div className="skeleton-swatch skeleton-shimmer" />
        </div>
      </div>
    </div>
  );
};
